import React from 'react';

import { ColumnProps, InputType, RowProps } from '@/types/general';
import { aggregatorMap } from '@/lib/helpers';
import { CustomConfigInputV2 } from '@/components/core/custom-config-input-v2';

function typedEntries<T extends object>(obj: T): [keyof T, T[keyof T]][] {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
}

export function getGamesSettingsTableData({
  gameData,
  gameIdList = [],
  setGameData,
}: {
  gameData: any;
  gameIdList?: string[];
  setGameData: React.Dispatch<React.SetStateAction<any>>;
}): RowProps[] {
  const values = typedEntries(gameData);

  const listData: RowProps[] = values?.map(([key, __]) => {
    gameIdList.push(String(key));

    const columns: ColumnProps[] = [
      {
        type: {
          text: { content: aggregatorMap[key as string] },
        },
      },
      {
        type: {
          component: (
            <CustomConfigInputV2
              label=""
              type={InputType.NUMBER}
              name={`${String(key)}.feePercentage`}
              value={gameData[key]?.feePercentage}
              defaultData={gameData}
              setDefaultData={setGameData}
              numberProps={{
                isPercentage: true,
              }}
            />
          ),
        },
      },
      {
        type: {
          component: (
            <CustomConfigInputV2
              label=""
              type={InputType.NUMBER}
              name={`${String(key)}.feePerBet`}
              value={gameData[key]?.feePerBet}
              defaultData={gameData}
              setDefaultData={setGameData}
              numberProps={{
                isPercentage: true,
              }}
            />
          ),
        },
      },
      {
        type: {
          component: (
            <CustomConfigInputV2
              direction="row"
              label=""
              trueLabel="Active"
              falseLabel="Active"
              type={InputType.CHECKBOX}
              name={`${String(key)}.active`}
              value={Boolean(gameData[key]?.active)}
              defaultData={gameData}
              setDefaultData={setGameData}
            />
          ),
        },
        textAlign: 'center',
      },

      // {
      //   type: {
      //     status: item.status,
      //   },
      //   textAlign: 'center',
      // },

      // {
      //   type: {
      //     time: item.updatedAt,
      //   },
      // },

      // {
      //   type: {
      //     detailsDrawer: {
      //       drawerState: GeneralDrawer.GENERAL_GAME_DETAILS,
      //       onClick: () => {
      //         dispatch(setGeneralGameDetails({ gameId: item.gameId }));
      //         dispatch(showDrawerState(GeneralDrawer.GENERAL_GAME_DETAILS));
      //       },
      //     },
      //   },
      //   textAlign: 'end',
      // },
    ];

    return {
      id: String(key),
      row: columns,
    };
  });

  return listData;
}
